// extracted by mini-css-extract-plugin
module.exports = {"content":"ReplaceSubmissionLink_content__3Wk_e"};